import React, { useEffect, useState } from "react";
import Styles from "./CompanyDetails.module.css";
import { getBankingListings } from "../../../Services/GNA/GetData";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ViewInjectDrawal from "../../Modals/Banking/ViewInjectDrawal/ViewInjectDrawal";
import {
  downloadListing,
  getDocumentUrlByLedgerId,
} from "../../../Services/ApiCalling/banking";
import PreviewModal from "../../../commons/PreviewModal/PreviewModal";
import DownloadIcon from "@mui/icons-material/Download";
import { SuccessMessage } from "../../../commons/Toast/ErrorMessage";
import { downloadBankingSuperAdmin } from "../../../Services/GNA/AlterApi";
import { useLocation } from "react-router-dom";
import ListingDetails from "../../Modals/Admin/ListingDetails/ListingDetails";

const DiscomDetails = ({ index, discom }) => {
  const location = useLocation();
  let companyId = location?.search?.split("=")[1];
  console.debug("discom", discom);
  const [viewType, setViewType] = useState("details");
  const [bankingList, setBankingList] = useState(null);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedListing, setSelectedListing] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  console.debug("bankingList", bankingList);
  const [listingView, setListingView] = useState({
    open: false,
    data: null,
  });

  useEffect(() => { 
    if (viewType === "listing") {
      handleFetchBankingDetails();
    }
  }, [viewType]);

  const handleFetchBankingDetails = async () => {
    let res = await getBankingListings({ companyId: companyId });
    if (res?.data?.code === 200) {
      setBankingList(res.data?.data?.page);
    }
  };
  const handleOpenView = (listing) => {
    setSelectedListing(listing);
    setViewDetails(true);
  };

  const handleCloseView = () => {
    setViewDetails(false);
  };

  const handleViewTermsDocument = async (termsDocumentId) => {
    if (!termsDocumentId || termsDocumentId === 0) {
      console.warn("No terms document ID available");
      return;
    }

    try {
      const response = await getDocumentUrlByLedgerId(termsDocumentId);
      const url = response?.data || response;
      if (url) {
        setPreviewFileUrl(url);
        setPreviewModal(true);
      } else {
        console.error("No URL found for terms document");
      }
    } catch (error) {
      console.error("Error viewing terms document:", error);
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
  };

  const handleDownload = async (id, name, userId, companyId) => {
    const response = await downloadBankingSuperAdmin({
      id,
      companyId: companyId,
      userId: userId,
    });
    const blob = response.data;
    if (!blob) return;
    const url = window.URL.createObjectURL(
      new Blob([blob], {
        type: "application/pdf",
      })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `listing_${name}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    SuccessMessage("Listing downloaded successfully!");
  };

  return (
    <>
      {viewDetails && (
        <ViewInjectDrawal
          open={viewDetails}
          handleClose={handleCloseView}
          data={selectedListing}
        />
      )}
      {previewModal && (
        <PreviewModal
          open={previewModal}
          onClose={handleClosePreview}
          fileUrl={previewFileUrl}
        />
      )}
      {listingView.open && (
        <ListingDetails
          open={listingView.open}
          handleClose={() => setListingView({ open: false, data: null })}
          data={listingView.data}
          type="banking"
        />
      )}
      <div className={`display_flex_row_center ${Styles.viewTypeContainer}`}>
        <div
          onClick={() => setViewType("details")}
          className={viewType === "details" ? `activeButton` : ""}
        >
          Details
        </div>
        <div
          onClick={() => setViewType("listing")}
          className={viewType === "listing" ? `activeButton` : ""}
        >
          Listing
        </div>
      </div>
      {viewType === "details" && (
        <div key={index} className={Styles.detailRow}>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Discom Name</div>
            <div>{discom.discomName || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Discom Acronym</div>
            <div>{discom.acronym || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Created At</div>
            <div>{discom.createdAt || "-"}</div>
          </div>
        </div>
      )}
      {viewType === "listing" && (
        <div>
          <div className={`display_flex_row tableHeading`}>
            <div style={{ width: "15%" }}>Listing ID</div>
            <div style={{ width: "10%" }}>Injection/Drawal</div>
            <div style={{ width: "10%" }}>BF(%)</div>
            <div style={{ width: "10%" }}>SR(₹/kWh)</div>
            <div style={{ width: "10%" }}>T&C</div>
            <div style={{ width: "15%" }}>Expires on</div>
            <div style={{ width: "10%" }}>Download</div>
            <div style={{ width: "10%" }}>Status</div>
            <div style={{ width: "10%" }}>Action</div>
          </div>
          <div className={`scroll_bar_y ${Styles.discomListingCOntainer}`}>
            {bankingList === null ? (
              <div className="pending">Loading...</div>
            ) : bankingList?.data?.length === 0 ? (
              <div className="pending">No Listings Available</div>
            ) : (
              <>
                {bankingList?.map((listing, idx) => (
                  <div className="display_flex_row tableDetails">
                    <div style={{ width: "15%" }}>{listing?.name}</div>
                    <div
                      style={{
                        width: "10%",
                        cursor: "pointer",
                        color: "#f1935c",
                      }}
                      onClick={() => handleOpenView(listing)}
                    >
                      View
                    </div>
                    <div style={{ width: "10%" }}>{listing?.bankingFactor}</div>
                    <div style={{ width: "10%" }}>
                      {listing?.settlementRate}
                    </div>
                    <div style={{ width: "10%" }}>
                      <RemoveRedEyeIcon
                        style={{
                          cursor: listing.termsDocumentId
                            ? "pointer"
                            : "no-drop",
                          fontSize: "16px",
                          color: listing.termsDocumentId
                            ? "#f1935c"
                            : "#8c8a96",
                        }}
                        onClick={() =>
                          handleViewTermsDocument(listing.termsDocumentId)
                        }
                      />
                    </div>
                    <div style={{ width: "15%" }}>{listing?.expiryAt}</div>
                    <div style={{ width: "10%" }}>
                      <DownloadIcon
                        style={{
                          cursor: "pointer",
                          fontSize: "16px",
                          color: "#f1935c",
                        }}
                        onClick={() =>
                          handleDownload(
                            listing.id,
                            listing.name,
                            listing.companyId,
                            listing.userId
                          )
                        }
                      />
                    </div>
                    <div style={{ width: "10%" }}>{listing?.status}</div>
                    <div style={{ width: "10%" }}>
                      <RemoveRedEyeIcon
                        onClick={() =>
                          (listing?.status === "COMPLETED" ||
                            listing?.status === "PAST") &&
                          setListingView({ open: true, data: listing })
                        }
                        style={{
                          cursor:
                            listing?.status === "COMPLETED" ||
                            listing?.status === "PAST"
                              ? "pointer"
                              : "no-drop",
                          fontSize: "16px",
                          color:
                            listing?.status === "COMPLETED" ||
                            listing?.status === "PAST"
                              ? "#f1935c"
                              : "#8c8a96",
                        }}
                      />
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DiscomDetails;
